var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMountain(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65023 3.05582L13.8842 12.2133C14.0307 12.4725 14.0385 12.7503 13.9057 12.9764C13.7728 13.2038 13.526 13.3333 13.2283 13.3333H2.77148C2.47383 13.3333 2.22633 13.2031 2.09347 12.9758C1.96125 12.7497 1.96972 12.4712 2.11626 12.2133L7.34956 3.05582C7.64721 2.53696 8.35258 2.53696 8.65023 3.05582ZM8.22493 3.29614L7.80027 3.53646L7.80022 3.53589L7.79962 3.53517L8.22493 3.29614ZM8.96286 5.56981L7.99957 3.88497L7.03758 5.56917L8.02302 6.54924L8.28094 6.24738L8.96286 5.56981ZM6.53672 6.44495L3.15576 12.3617H12.8447L9.46372 6.44495L8.66782 7.23653C8.48415 7.41985 8.24186 7.51118 7.99957 7.51118C7.75794 7.51118 7.51565 7.41985 7.33198 7.23653L6.53672 6.44495Z",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain);
export default __webpack_public_path__ + "static/media/Mountain.86e187dfbb323969ea30104ab4e49a35.svg";
export { ForwardRef as ReactComponent };